import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import DocIcon from "../../assets/img/DocIcon.svg";
import VactorIcon3 from "../../assets/img/VactorIcon3.svg";
import useTranslator from "../../hooks/useTranslator";
import noticIcon from "../../assets/img/noticIcon.svg";
import { haveValue } from "../../helper/common";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { useEffect, useState } from "react";
import FilePreviewModal from "../FilePreviewmodal";

const DataInfoModal = ({
  isOpen,
  onClose,
  handleUpdateSource,
  infoModal,
  verifiedDocs,
  claveDocs,
  docsMap,
  forensicAnalysis,
}) => {
  const { _t } = useTranslator();

  const [documentGalleryData, setDocumentGalleryData] = useState([]);
  const [filePreview, showFilePreview] = useState(false);
  const [showIndex, setShowIndex] = useState(null);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  useEffect(() => {
    if (!isOpen) return;

    const result = [];

    if (
      Array.isArray(infoModal?.foundInDocuments) &&
      docsMap &&
      verifiedDocs instanceof Map
    ) {
      infoModal.foundInDocuments.forEach((doc) => {
        const docMeta = docsMap[doc.documentId];
        if (!docMeta?.url) return;

        const url = docMeta.url;
        const uploadKey = url?.split("uploads/")[1];

        const isVerified = verifiedDocs.has(uploadKey);
        const isClave = claveDocs instanceof Map && claveDocs.has(uploadKey);

        result.push({
          ...doc,
          file_name: uploadKey,
          tick: isVerified,
          clave: isClave,
        });
      });
    }

    setDocumentGalleryData(result);
  }, [infoModal, docsMap, verifiedDocs, claveDocs, isOpen]);

  if (!isOpen) return;

  // console.log(
  //   "infoModal",
  //   infoModal,
  //   "verifiedDocs",
  //   verifiedDocs,
  //   "claveDocs",
  //   claveDocs,
  //   "docsMap",
  //   docsMap,
  //   "documentGalleryData",
  //   documentGalleryData
  // );

  console.log("infoModal", infoModal);

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal wrapper-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="doc-history-header">
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          <h4 className="custom-modal-heading">{_t("dataInfo")}</h4>
        </div>
        <div className="h-100 overflow-y-auto">
          <div className="row d-flex align-items-center ">
            <div className="col-6">
              <div className="">
                <p className="inpitnamehere">
                  {haveValue(infoModal?.keyFactor)
                    ? _t(infoModal?.keyFactor?.toLowerCase())
                    : _t("payslip")}
                </p>
                <p className="inpitplaceholder">
                  {haveValue(infoModal?.value)
                    ? infoModal?.value
                    : haveValue(infoModal?.netIncome)
                    ? `€${infoModal?.netIncome}`
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="col-6 text-end">
              <div className="d-flex align-items-center justify-content-end">
                {(infoModal?.verifiedSource === true ||
                  (forensicAnalysis?.Income?.verifiedSource === true &&
                    infoModal?.verified === true)) && (
                  <div className="verifyBtn d-flex gap-2 align-items-center">
                    <img src={CheckIcon0} alt="Vector Icon" />
                    <p className="inpitplaceholder inpitplaceholder2">
                      {_t("Verified")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="earner-card-wrapper earner-card-new">
            <div className="statusComponent mb-2">
              <p className="statusText">{_t("status")}</p>
              <p className="statusText2">
                {infoModal?.consitentAccrosDocuments ||
                (forensicAnalysis?.Income?.verifiedSource === true &&
                  infoModal?.verified)
                  ? _t("consistent")
                  : _t("notConsistent")}
              </p>
              <p className="statusText">{_t("remarks")}</p>
              <p className="statusText3">
                {typeof infoModal?.remarks === "object"
                  ? infoModal?.remarks?.[currentLang === "es" ? "es" : "en"] ||
                    "N/A"
                  : infoModal?.remarks || "N/A"}
              </p>
            </div>
          </div>
          {!haveValue(infoModal?.netIncome) &&
            documentGalleryData.length > 0 && (
              <div className="documents_fixed_div">
                <h4>{_t("foundInDocuments")}</h4>
                <div className="documents_fixed">
                  {documentGalleryData?.map((doc, index) => (
                    <div className="d-flex align-items-center gap-4 justify-content-between BorderB2">
                      <div className="d-flex align-items-center gap-2">
                        <div className="docList">
                          <img
                            src={DocIcon}
                            alt="Vector Icon"
                            className="vactorImg2"
                          />
                        </div>
                        <div
                          onClick={(e) => {
                            console.log("doc?.documentName", doc?.file_name);
                            setShowIndex(index);
                            showFilePreview(true);
                          }}
                          className="texReport_div text-decoration-underline-hover cursor-pointer"
                        >
                          <p>{_t(doc?.documentName, "", "fixed")}</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {doc?.clave && (
                          <div className="clickBtn2 d-flex align-items-center gap-2">
                            <img
                              src={VactorIcon3}
                              alt="Vector Icon"
                              className="vactorImg2"
                            />
                            <p>Cl@ve</p>
                          </div>
                        )}
                        {doc?.tick && (
                          <div>
                            <img
                              src={CheckIcon0}
                              alt="Vector Icon"
                              className="vactorImg"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
        </div>
      </div>
      <FilePreviewModal
        show={filePreview}
        onClose={() => {
          showFilePreview(false);
        }}
        files={documentGalleryData}
        showIndex={showIndex}
      />
    </div>
  );
};

export default DataInfoModal;
